import { CHANGE_LANGUAGE } from '../actions/constants';
import LocalStorage from '../utils/LocalStorageService';

function initialLanguage() {
  const storedLanguage = LocalStorage.getSelectedLanguage();

  if (storedLanguage && storedLanguage !== 'undefined') {
    return storedLanguage;
  } else {
    return 'nl-NL';
  }
}

const defaultState = {
  languageCode: initialLanguage(),
};

const languageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE: {
      return {
        ...state,
        languageCode: action.languageCode,
      };
    }
    default:
      return state;
  }
};

export default languageReducer;
